export default {
  namespaced: true,
  actions: {
  },
};
